// extracted by mini-css-extract-plugin
module.exports = {"ProgressText":"ProgressBar_ProgressText__2VsAL","ProgressBar":"ProgressBar_ProgressBar__3Qzfo","inner":"ProgressBar_inner__3SC89","progress":"ProgressBar_progress__1x8JT"};